










import Vue from "vue";
import { store } from "../../services/store";
import { blockActivity, TaskStatus } from "../../services/index";
import { parseParamToObj } from "@/utils/detect";
import { logger, ActionType } from "@/utils/logger";
import { toast } from "@bilibili/growup-utils";
import { closeBrowser } from "@/utils/bridge";
const search: any = parseParamToObj(location) || {};

export default Vue.extend({
  data() {
    return {
      desc: "退出活动将清除当前进行的任务且无法再次进入该活动哦！"
    };
  },
  computed: {
    status(): number {
      return store.status;
    }
  },
  methods: {
    close() {
      this.$dialog.close("quit");
    },
    quit() {
      // 屏蔽活动
      blockActivity()
        .then(({ code, message }) => {
          if (code === 0) {
            closeBrowser();
          } else {
            toast(message);
          }
        })
        .finally(() => {
          this.$dialog.close("quit");
        });
      // 上报埋点
      logger("activity.red-packet.active-page.bad.click", ActionType.View, {
        from_channel: search["from_channel"],
        box_type: search["boxType"] ? decodeURIComponent(search["boxType"]) : "",
        is_task: this.status === 2 ? TaskStatus.HasTask : TaskStatus.NotHasTask
      });
    }
  }
});
